"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"

import { adminSignupOnboardingQueryKey } from "@/hooks/queries/admin-signup-onboarding"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { restartAdminSignupOnboardingAction } from "@/server-actions/admin-signup-onboarding"
import { useTranslations } from "next-intl"


export function useRestartAdminSignupOnboardingMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsAdminSignupOnboarding")

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (tenantId: string) => {
      const result = await withQueryHandling(
        restartAdminSignupOnboardingAction({ tenant_id: tenantId }),
        {
          loading: tUi("restartingOnboarding"),
          success: tUi("onboardingRestarted"),
        },
      )
      if ("status" in result) throw new Error(result.errorMessage)
      return result.state
    },
    onSuccess: async (_state, tenantId) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [...adminSignupOnboardingQueryKey, "summaries"],
        }),
        queryClient.invalidateQueries({
          queryKey: [
            ...adminSignupOnboardingQueryKey,
            "details",
            tenantId,
          ],
        }),
      ])
    },
  })
}
